/*
 * @Author: liyxt
 * @Date: 2020-05-19 15:47:39
 * @LastEditors: bbqin
 * @LastEditTime: 2022-05-19 17:14:54
 * @Description: file content
 */
import React, { Component } from 'react';
//import OriginTransfer from 'bee-transfer';
import { Transfer as OriginTransfer } from '@tinper/next-ui';

//require('bee-transfer/build/Transfer.css');
require('./index.less');

/**
 * @namespace BaseTransfer
 */

/**
 * 穿梭框组件的参数描述
 * @memberof BaseTransfer
 * @component Transfer
 * @property {array<SourceItem>} [dataSource = []] - 设置数据源。当有targetKey props存在时，dataSource的数据刨去targetKey数据,剩下的都放在左边列表
 * @property {function(record): record.title} render - 每行数据渲染函数，该函数的入参为 dataSource 中的项，返回值为 ReactElement。或者返回一个普通对象，其中 label 字段为 ReactElement，value 字段为 title
 * @property {array<TargetKey>} [targetKeys = []] - 展示在右边列表的数据集
 * @property {array<TargetKey>} [selectedKeys = []] - 	所有选中的item的keys
 * @property {function(targetKeys, Direction, moveKeys): void}  onChange - 当item在穿梭成功后的回调 参数(targetKeys, direction, moveKeys)
 * @property {function(sourceSelectedKeys, targetSelectedKeys): void}  onSelectChange - 当选中的item发生改变时的回调 参数(sourceSelectedKeys, targetSelectedKeys)
 * @property {function(Direction, event): void}  onScroll - 当滑动可选的item列表的回调 参数(direction, event)
 * @property {object}  listStyle - 自定义的columns的样式表，cssStyle
 * @property {string}  className - 整个组件的className
 * @property {array<string>}  titles - 左右两columns的title
 * @property {array|object}  [operations=['rightAll', 'rightOne', 'leftAll', 'leftOne']] - 自定义按钮操作, 内置选项包含rightAll, rightOne, leftAll, leftOne，可以设置为object{rightOne: {text: '向右'}, leftOne: {text: '向左'}}
 * @property {boolean}  [showSearch=false] - 是否显示搜索框
 * @property {boolean|function(filterValue, option): boolean}  filterOption - 搜索过滤方法 参数(filterValue, option)
 * @property {string}  [searchPlaceholder=Search] - 搜索框的默认显示文字
 * @property {string|ReactNode}  [notFoundContent=Not Found] - 当没有相关内容的显示内容
 * @property {ReactNode}  footer - 渲染底部的dom
 * @property {object}  lazy - 懒加载dom，当tranfer放在modal里 添加参数 lazy={container:"modal"}
 * @property {function(Direction, value): void}  onSearchChange - 当搜索域变化的回调函数 参数(direction: 'left'|'right', value)
 * @property {boolean}  [showCheckbox=true] - 是否显示Checkbox复选框
 * @property {boolean}  [draggable=false] - 是否可以通过拖拽进行穿梭和排序
 * @property {boolean}  [appendToBottom=false] - 是否将已选项追加到右侧列表末尾
 * @property {function(): ReactNode}  renderOperation - 自定义扩展操作栏
 * @property {string}  fieldid - 自动化测试专用属性
 */
export default class Transfer extends Component {
    render() {
        let { className } = this.props
        return <OriginTransfer {...this.props} className={`base-transfer ${className}`} />;
    }
}
